<template lang="pug">
div
  #preloader(v-if="gameLaunching")
    #loader
  .gameplay-wrapper.vv-gp
    .gpnav
      .items.vv-gpnav-show
        div(@click="triggerMenu(1)")
          svg(id='fi_3018442' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg')
            circle(cx='12' cy='12' r='2')
            circle(cx='4' cy='12' r='2')
            circle(cx='20' cy='12' r='2')
        div(@click="redirectPath()")
          svg(enable-background='new 0 0 512 512' height='24' viewBox='0 0 512 512' width='24' xmlns='http://www.w3.org/2000/svg' id='fi_5254940')
            path(d='m292.2 256 109.9-109.9c10-10 10-26.2 0-36.2s-26.2-10-36.2 0l-109.9 109.9-109.9-109.9c-10-10-26.2-10-36.2 0s-10 26.2 0 36.2l109.9 109.9-109.9 109.9c-10 10-10 26.2 0 36.2 5 5 11.55 7.5 18.1 7.5s13.1-2.5 18.1-7.5l109.9-109.9 109.9 109.9c5 5 11.55 7.5 18.1 7.5s13.1-2.5 18.1-7.5c10-10 10-26.2 0-36.2z')
    .gpholder
      iframe.vv-gp-iframe(:src="gameUrl")
  .gameplay-popover-wrapper.vv-gppop(v-if="showMenu")
    .gppop
      .overlay
      .ccon
        .items
          router-link(to="deposit") Deposit
          //- a(href='#') Add Favorite
          //- a(href='#') Reload
        a(href='javascript:void(0)' @click="triggerMenu(2)") Cancel
//- .lobby
  .float-button.pointer(@click="redirectPath()") BACK
  .container
    iframe.responsive-iframe(:src='gameUrl')

</template>
<script>
import config from '@/config'
import _ from "lodash";
export default{
  data(){
    return{
      // gameId: "",
      // gameName: "",
      gameUrl: "",
      showMenu: false,
      gameLaunching: true,
      userPlatform:null
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    lobbySource(){
      return this.$store.state.user.account.lobbySource
    },
    lobbyProvider(){
      return this.$store.state.user.account.lobbyProvider
    },
  },
  created(){
    this.getMobile()
  },
  mounted(){
    window.scroll(0,0)
    if(!_.isEmpty(this.$route.params)){
      // this.launchGame(this.$route.params.id, this.$route.params.name)
      // this.gameUrl = this.$route.params.link
      this.$store.dispatch("user/lobbySource", this.$route.params.source);
      this.$store.dispatch("user/lobbyProvider", this.$route.params.provider);
      this.launchGame(this.$route.params.id, this.$route.params.name, this.$route.params.code, this.$route.params.type)
    }else{
      var vm = this
      if(this.lobbySource !==""){
        this.$swal({
          title: vm.$tc("ui.attention"),
          text: "Please relaunch the game from the menu",
          showCancelButton: false,
          type: "info",
          confirmButtonText: vm.$tc("ui.ok"),
        }).then(result => {
          if (result.value) {
            vm.redirectPath()
          }
        });
      }
    }
  },
  methods:{
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.userPlatform = "mobile"
      }else{
        this.userPlatform = "web"
      }
    },
    triggerMenu(option){
      if(option === 1){
        this.showMenu = true
      }else{
        this.showMenu = false
      }
      
    },
    launchGame(game, name, provider, type){
      switch(provider){
        case "FC":
          this.path = "user/launchFc"
          break;
        case "JILI2":
          this.path = "user/launchJili"
          break;
        case "EPIC2":
          this.path = "user/launchEpic2"
          break;
        case "EVO":
          this.path = "user/launchEvo"
          break;
        case "PG":
        case "FASTSPIN":
        case "YESBINGO":
        case "YL":
        case "JDB":
        case "SEXYBCRT":
        case "VENUS":
          this.path = "user/launchAwc"
          break;
        case "PP-S1":
        case "MG":
        case "SPNX":
        case "SPDG":
        case "BG-S":
        case "HSD":
        case "RG":
        case "EVOP":
        case "PNG":
        case "EVONTT":
        case "EVORT":
        case "EVONLC":
        case "BNG":
        case "AP":
        case "ALG":
        case "SPB":
        case "QM":
        case "PP-C1":
        case "WIFY":
        case "YB":
          this.path = "user/launchLaunchOne"
          break;
        case "PG2":
          this.path = "user/launchOpenapi"
          break;
        case "LIVE22":
          this.path = "user/launchLive22"
          break;
        case "YGR":
          this.path = "user/launchYgr"
          break;
        case "SPORTS":
          this.path = "user/launchWbet"
          break;
        case "DS88":
          this.path = "user/launchSabong"
          break;
        case "IRONCLAW":
          this.path = "user/launchIronclaw"
          break;
        case "PP-S123":
          this.path = "user/launchPps"
          break;
        case "CQ9":
          this.path = "user/launchCq9"
          break;
        case "WOW":
          this.path = "user/launchWow"
          break;
        default:
          this.path = "user/launchAwc"
          break;
      }
      if (this.sessionToken) {
        this.gameLaunching = true
        var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let lang_code = "en"
        let game_name = name
        let game_type = type
        let platform = this.userPlatform
        this.$store
          .dispatch(this.path, { player_id, auth_token,game_code, lang_code, game_name, provider, game_type, platform, type})
          .then(response => {
            if (response.success == true) {
              // setTimeout(() => {
                var vm = this
                if(response.data === null || response.data === undefined || response.data === "" || response.data.length === 0){
                  
                  if(this.lobbySource !==""){
                    this.$swal({
                      title: vm.$tc("ui.attention"),
                      text: "Please relaunch the game from the menu",
                      showCancelButton: false,
                      type: "info",
                      confirmButtonText: vm.$tc("ui.ok"),
                    }).then(result => {
                      if (result.value) {
                        vm.redirectPath()
                      }
                    });
                  }
                }else{
                  this.gameUrl = response.data
                  vm.gameLaunching = false
                }
                
              // }) 
            } else {
              var vm = this
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status_desc), "info", this);
              }
            }
          })
          .catch(response => {
            var vm = this
            vm.gameLaunching = false
            if(response.status === null){
              this.$swal({
                title: "Attention",
                text: "Please relaunch the game from the menu",
                showCancelButton: false,
                type: "info",
                confirmButtonText: "OK",
              }).then(result => {
                if (result.value) {
                  vm.redirectPath()
                }
              });
            }
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                    
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("/deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                // this.$helpers.showDialog(this.$t("ui.attention"), response.status, "info", this);
              }
            }
          });
      }else{
        $("#logModal").modal("show")
      }
    },
    redirectPath(){
      var vm = this
      if(this.lobbySource !== ""){
        this.$router.push({
          name: vm.lobbySource,
          params:{
            "provider": vm.lobbyProvider
          }
        }).catch(error =>{})
      }else{
        this.$router.push("/"+vm.lobbySource).catch(error =>{})
      }
      // this.$router.push("/slot").catch(error =>{})
    }
  }
}
</script>
<style lang="scss" scoped>
.lobby{
  padding: 0;
  margin: 0;
  border: 0;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
  border: 0;
}
.responsive-iframe {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
.float-button {
  font-family: Tahoma;
  font-weight: bold;
  padding: 16px;
  position: absolute;
  left: 0;
  top: 0;
  margin: 4px;
  z-index: 1000;
  background: #ffffffcc;
  border-radius: 5px;
  
}
</style>